// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plus-offer{max-width:30.625rem;padding:0 1.5rem}", "",{"version":3,"sources":["webpack://./src/components/v1/invitation/ts-plus-offer/index.scss"],"names":[],"mappings":"AAAA,YACE,mBAAA,CACA,gBAAA","sourcesContent":[".plus-offer {\n  max-width: 30.625rem;\n  padding: 0 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
